<template>
  <div class="d-flex flex-column">
    <div class="HeaderApp header-wesave d-flex align-center">
      <HeaderAppDesktop
        :logo="logo"
        :adminHeader="adminHeader"
        :maxWidth="maxWidth"
      />

      <HeaderAppMobile
        :logo="logo"
        :adminHeader="adminHeader"
      />
    </div>
    <div
      v-if="validatedMessage"
      class="d-flex review-bar white--text"
    >
      <v-icon color="white">mdi-reload</v-icon>
      <div class="message d-flex align-center">
        {{ validatedMessage }}
      </div>
    </div>
    <div
      v-if="checkErrorsPresent"
      class="d-flex review-bar checks-error white--text"
    >
      <v-icon color="white">mdi-alert-box</v-icon>
      <div class="message d-flex align-center">
        {{ $t('main.enums.error.checks-error') }}
      </div>
    </div>
  </div>
</template>

<script>
  import CommonMixin from '@/mixins/store/CommonMixin'
  import HeaderAppDesktop from '@/components/ui/partials/HeaderApp/HeaderAppDesktop/HeaderAppDesktop'
  import HeaderAppMobile from '@/components/ui/partials/HeaderApp/HeaderAppMobile/HeaderAppMobile'
  import { SUBSCRIBER } from '@/components/ui/partials/HeaderApp/HeaderApp.const'
  import { PERSON_STATUS } from '@/services/models.const'

  export default {
    components: {
      HeaderAppMobile,
      HeaderAppDesktop,
    },
    mixins: [CommonMixin,],
    props: {
      maxWidth: {
        type: Number,
        default: 1024,
      },
      adminHeader: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        logo: './assets/icons/ai.png',
        SUBSCRIBER,
      }
    },
    computed: {
      validatedMessage() {
        if (this.currentUserRole !== SUBSCRIBER) {
          return ''
        }
        const customerFileStatus = this.currentUser.meta.customer_file_status

        if (customerFileStatus === PERSON_STATUS.validated_by_user) {
          return this.$t(`main.enums.status.messages.${customerFileStatus}`)
        }

        if (
          customerFileStatus === PERSON_STATUS.validated_by_advisor ||
          customerFileStatus === PERSON_STATUS.completed
        ) {
          return this.$t('main.enums.status.messages.completed')
        }

        return ''
      },
      checkErrorsPresent() {
        if (this.isCRM) {
          return false
        }
        let result = false
        const allPeopleDetails = [...this.peopleDetails, this.currentUser,]
        allPeopleDetails.every((person) => {
          if (!person.person_controls || person.person_controls) {
            return
          }
          const hasChecksErrors = Object.values(person.person_controls[0].checks).some(
            (val) => !val && val !== null
          )
          if (hasChecksErrors) {
            result = true

            return false
          }

          return true
        })

        return result
      },
    },
  }
</script>

<style lang="scss" rel="stylesheet/scss">
.HeaderApp {
  top: 0;
  position: fixed;
  width: 100%;
  padding: 8px 0;
  z-index: 200;
  font-weight: 400;
  font-size: 1em;
  background-color: $color-102d69 !important;
  box-shadow: 0 16px 32px 0 rgba(31, 54, 139, 0.12);
}
.review-bar {
  position: fixed;
  padding: 0.7rem 1rem;
  z-index: 9;
  width: 100%;
  top: 85px;
  @media (max-width: 959px) {
    z-index: 90;
    top: 50px;
  }
  background-color: $color-00d367;
  &.checks-error {
    background-color: $color-ff524f;
  }
  .message {
    margin-left: 0.5rem;
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 20px;
  }
}

.v-list {
  padding: 0 !important;
}
</style>
